import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "STATUS:")
], -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "PERÍODO:")
], -1)
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_7 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 2,
  class: "visualizar",
  title: "Importado"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["title"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  key: 4,
  style: {"margin-right":"5px"}
}
const _hoisted_18 = { key: 5 }
const _hoisted_19 = { key: 6 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-18" }, " Manifestar Nota Contra CNPJ ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Concluir Manifestação", -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_busca_rapida = _resolveComponent("busca-rapida")!
  const _component_selecionar_status_contra_nota = _resolveComponent("selecionar-status-contra-nota")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_busca_rapida, {
              buscaRapida: _ctx.state.valorBusca,
              "onUpdate:buscaRapida": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.valorBusca) = $event)),
              placeholder: "Digite a chave de acesso, dados do emitente ou valor da NF-e...",
              onBuscarDados: _ctx.buscarNotas
            }, null, 8, ["buscaRapida", "onBuscarDados"])
          ]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_selecionar_status_contra_nota, {
              valor: _ctx.state.status,
              "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.status) = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscarNotas()))
            }, null, 8, ["valor"])
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
              valor: _ctx.state.filtroPeriodo,
              "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.filtroPeriodo) = $event)),
              ocultarPeriodoPersonalizado: false,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscarNotas()))
            }, null, 8, ["valor"]),
            ((_ctx.state.filtroPeriodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Data Inicial e Final",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data_inicial_final, {
                          dataInicialSelecionada: _ctx.state.dataInicial,
                          "onUpdate:dataInicialSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dataInicial) = $event)),
                          dataFinalSelecionada: _ctx.state.dataFinal,
                          "onUpdate:dataFinalSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.dataFinal) = $event)),
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.buscarNotas()))
                        }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_spin, {
      spinning: _ctx.state.importando,
      tip: "Aguarde por favor..."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          loading: _ctx.state.buscandoNotas,
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.state.notasContraCnpj,
          rowKey: "codigo",
          pagination: false,
          size: "small",
          rowClassName: "ss-table-campos",
          bordered: ""
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhuma Nota fiscal foi encontrada!" })
          ]),
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  ((!record.manifestado))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "visualizar",
                        title: "Manifestar",
                        onClick: ($event: any) => (_ctx.apresentarModalManifestacao(record.codigo))
                      }, [
                        _createVNode(_component_icone, {
                          style: {"font-size":"18px"},
                          nome: "correto"
                        })
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  ((record.xmlDisponivel && !record.importado))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "visualizar",
                        title: "Importar",
                        onClick: ($event: any) => (_ctx.importarNFe(record.codigo))
                      }, [
                        _createVNode(_component_icone, {
                          style: {"font-size":"18px"},
                          nome: "download"
                        })
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  ((record.importado))
                    ? (_openBlock(), _createElementBlock("a", _hoisted_12, [
                        _createVNode(_component_icone, {
                          style: {"font-size":"18px"},
                          nome: "correto-circulo"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'Emitente')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(record.cpfCnpj)) + " " + _toDisplayString(record.nomeRazaoSocial), 1))
                : (column.key === 'NumeroNotaFiscal')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (record.numero > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            title: record.numero
                          }, _toDisplayString(record.numero), 9, _hoisted_14))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
                    ], 64))
                  : (column.key === 'DataEmissao')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        title: _ctx.UtilitarioData.aplicaFormatoData(record.dataEmissao)
                      }, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataEmissao)), 9, _hoisted_16))
                    : (column.key === 'Valor')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor, 2, true)), 1))
                      : (column.key === 'StatusNota')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.obterStatusNota(record.statusNota)), 1))
                        : (column.key === 'ChaveAcesso')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(record.chaveAcesso), 1))
                          : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "data-source"])
      ]),
      _: 1
    }, 8, ["spinning"]),
    (_ctx.state.apresentarModalManifestacao)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          keyboard: false,
          visible: _ctx.state.apresentarModalManifestacao,
          "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.apresentarModalManifestacao) = $event)),
          width: 500,
          centered: ""
        }, {
          title: _withCtx(() => [
            _hoisted_20
          ]),
          closeIcon: _withCtx(() => [
            _createVNode(_component_icone, { nome: "voltar" })
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.manifestarNFe()))
              }, _hoisted_22)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              style: {"display":"block"},
              value: _ctx.state.codigoEvento,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.codigoEvento) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, {
                  style: _normalizeStyle(_ctx.radioStyle),
                  value: 210210
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ciência da Operação")
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createVNode(_component_a_radio, {
                  style: _normalizeStyle(_ctx.radioStyle),
                  value: 210200
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Confirmar Operação")
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createVNode(_component_a_radio, {
                  style: _normalizeStyle(_ctx.radioStyle),
                  value: 210220
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Operação Desconhecida")
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createVNode(_component_a_radio, {
                  style: _normalizeStyle(_ctx.radioStyle),
                  value: 210240
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Operação não Realizada")
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}